"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TextCreativeLayer = _interopRequireDefault(require("../../models/creative/TextCreativeLayer"));

var _BaseRenderer = _interopRequireDefault(require("./BaseRenderer"));

var _LayerRenderer2 = _interopRequireDefault(require("./LayerRenderer"));

var _text = require("../../constants/text");

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _setCanvasTextDirection = _interopRequireDefault(require("../../text/canvas/setCanvasTextDirection"));

var _isRTLText = _interopRequireDefault(require("../../utils/string/isRTLText"));

var _getTextAlign = _interopRequireDefault(require("../../utils/text/getTextAlign"));

var _setContextTransform = _interopRequireDefault(require("./transform/setContextTransform"));

var _getCanvasFontProperty = _interopRequireDefault(require("../../utils/font/getCanvasFontProperty"));

var _models = require("../../models");

var _BoxFillTextEffect = _interopRequireDefault(require("./text/BoxFillTextEffect"));

var _DropShadowTextEffect = _interopRequireDefault(require("./text/DropShadowTextEffect"));

var _InnerShadowTextEffect = _interopRequireDefault(require("./text/InnerShadowTextEffect"));

var _LineFillTextEffect = _interopRequireDefault(require("./text/LineFillTextEffect"));

var _NoneTextEffect = _interopRequireDefault(require("./text/NoneTextEffect"));

var _OuterGlowTextEffect = _interopRequireDefault(require("./text/OuterGlowTextEffect"));

var _TextEffect = _interopRequireDefault(require("./text/TextEffect"));

var _TextFrameData = _interopRequireDefault(require("../store/TextFrameData"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextRenderer = /*#__PURE__*/function (_LayerRenderer) {
  (0, _inherits2["default"])(TextRenderer, _LayerRenderer);

  var _super = _createSuper(TextRenderer);

  function TextRenderer(creativeLayer, contentStore, layerTransformer, filterProcessor, canvasFactory) {
    var _this;

    (0, _classCallCheck2["default"])(this, TextRenderer);
    _this = _super.call(this, creativeLayer, contentStore, layerTransformer, filterProcessor);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_canvasFactory", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_textCanvas", null);

    if (!_TextCreativeLayer["default"].isTextCreativeLayer(creativeLayer)) {
      throw new Error('Must be initialized with a creative layer of the content type TEXT');
    }

    _this._contentScaleMode = _BaseRenderer["default"].SCALE_MODE_OVERFLOW;
    _this._canvasFactory = canvasFactory;
    _this._textCanvas = _this._canvasFactory.getCanvas();
    _this._textEffectCanvas = _this._canvasFactory.getCanvas();
    return _this;
  }

  (0, _createClass2["default"])(TextRenderer, [{
    key: "drawLayerAtFrame",
    value: function drawLayerAtFrame(context, currentFrame, contentFrameData, layerTransformData) {
      if (!_TextFrameData["default"].isTextFrameData(contentFrameData)) {
        // This should rarely happen, but if it does just don't draw anything
        return;
      } // Draw the text!


      var textRenderProperties = contentFrameData.textRenderProperties;
      if ((0, _isNil["default"])(textRenderProperties)) return;
      var finalCanvas = context.canvas;
      var textCanvas = this._textCanvas;
      var textContext = textCanvas.getContext('2d');
      textCanvas.width = finalCanvas.width;
      textCanvas.height = finalCanvas.height;
      var isRTL = (0, _isRTLText["default"])(textRenderProperties.textString);
      var textDirection = isRTL ? _text.TEXT_DIRECTION.RTL : _text.TEXT_DIRECTION.LTR;
      var rotation = layerTransformData.rotation,
          scaleX = layerTransformData.scaleX,
          scaleY = layerTransformData.scaleY,
          translationX = layerTransformData.translationX,
          translationY = layerTransformData.translationY; // Set transform on text canvas, reset transform on final canvas.

      (0, _setContextTransform["default"])(textContext, translationX, translationY, scaleX, scaleY, rotation, new _models.Rectangle(0, 0, textCanvas.width, textCanvas.height));
      (0, _setContextTransform["default"])(context, 0, 0, 1, 1, 0, new _models.Rectangle(0, 0, finalCanvas.width, finalCanvas.height));
      textContext.clearRect(-textCanvas.width / 2, -textCanvas.height / 2, textCanvas.width, textCanvas.height); // Set text direction and font properties on Text Canvas.
      // TODO create a util to apply all these properties on a canvas

      (0, _setCanvasTextDirection["default"])(textContext, textDirection);
      textContext.font = (0, _getCanvasFontProperty["default"])(textRenderProperties.fontName, textRenderProperties.renderedFontSize);
      textContext.fillStyle = textRenderProperties.fillColor;
      textContext.textAlign = (0, _getTextAlign["default"])(textRenderProperties.horizontalAlignment, isRTL);
      var wrapWidth = textRenderProperties.wrapProperties.get('width');
      var wrapHeight = textRenderProperties.wrapProperties.get('height');
      textContext.translate(-wrapWidth / 2, -wrapHeight / 2);

      var textEffectContext = this._textEffectCanvas.getContext('2d');

      this._textEffectCanvas.width = textCanvas.width;
      this._textEffectCanvas.height = textCanvas.height; // Apply text Effect

      _TextEffect["default"].apply(textContext, textEffectContext, null, contentFrameData, layerTransformData);

      var textEffectType = textRenderProperties.textEffect.get('type');

      switch (textEffectType) {
        case _text.TEXT_EFFECTS.BOX_FILL:
          _BoxFillTextEffect["default"].apply(textContext, textEffectContext, null, contentFrameData, layerTransformData);

          break;

        case _text.TEXT_EFFECTS.DROP_SHADOW:
          _DropShadowTextEffect["default"].apply(textContext, textEffectContext, null, contentFrameData, layerTransformData);

          break;

        case _text.TEXT_EFFECTS.HIGHLIGHT:
          _LineFillTextEffect["default"].apply(textContext, textEffectContext, null, contentFrameData, layerTransformData);

          break;

        case _text.TEXT_EFFECTS.INNER_SHADOW:
          _InnerShadowTextEffect["default"].apply(textContext, textEffectContext, null, contentFrameData, layerTransformData);

          break;

        case _text.TEXT_EFFECTS.OUTER_GLOW:
          _OuterGlowTextEffect["default"].apply(textContext, textEffectContext, null, contentFrameData, layerTransformData);

          break;

        default:
          _NoneTextEffect["default"].apply(textContext, textEffectContext, null, contentFrameData, layerTransformData);

          break;
      } // Transfer to main context.


      context.drawImage(textCanvas, 0, 0, textCanvas.width, textCanvas.height, -finalCanvas.width / 2, -finalCanvas.height / 2, finalCanvas.width, finalCanvas.height);
    }
  }]);
  return TextRenderer;
}(_LayerRenderer2["default"]);

exports["default"] = TextRenderer;